import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvVariables} from "helpers/getEnvVariables";

const {REACT_APP_URL} = getEnvVariables();
export const raffleApi = createApi({
  reducerPath: "raffle",
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_URL,
    responseHandler: async (response) => {
      const data = await response.json();
      return {
        ...data,
        meta: {
          status: response.status,
        },
      };
    },
  }),
  endpoints: (builder) => ({
    getRaffle: builder.query({
      query: (eventId) => ({
        url: `api/v2/customer/raffle/numbers/progress`,
        params: {event: eventId},
      }),
    }),
    getCombos: builder.query({
      query: (eventId) => ({
        url: "api/v2/customer/combo/raffle",
        params: {event: eventId},
      }),
    }),
  }),
});

export const {useLazyGetRaffleQuery, useGetCombosQuery} = raffleApi;
